import { memo, useEffect, useState } from "react";
import { Col, Container, Row, Stack } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getAssetExchangeNameFromMktSegId, getDecryptLocalStorage } from "../../utils/global_functions";
import { LOCAL_STORAGE_KEYS, THEME_TYPE, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { getQuarterlyTrendData } from "../../redux/actions/marketOverview";
import ZeroStates from "../ZeroStates";
import { Bar } from "react-chartjs-2";

const apiQuarterlyTrendValues = {
    'netrevenue': 'QuarterlyTrend-Revenue',
    'ebit': 'QuarterlyTrend-EBIT',
    'ebitda': 'QuarterlyTrend-EBITDA',
    'netprofit': 'QuarterlyTrend-Netprofit'
};
const TrendAnalysis = ({ expandScripOverviewModel }) => {
    const dispatch = useDispatch();
    const trendAnalysis = useSelector(state => state.marketOverview.quarterlyTrend);
    const [filterTrendAnalysis, setfilterTrendAnalysis] = useState([]);
    const [activeTabKey, setActiveTabKey] = useState('netrevenue');
    const [lables, setLables] = useState(["Net Revenue", "Gross Profit Margin"]);
    const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);

    useEffect(() => {
        if (trendAnalysis?.length) {
            let dataFilterVal = [];
            trendAnalysis.forEach((value) => {
                // Vaibhav Singh: BT-109095:09-11-23:Fixed value to decimal locator length: Start
                dataFilterVal.push({
                    yrc: new Date(value?.yrc.slice(-2)).toLocaleDateString('en-US', { 'month': 'short' }) + value?.yrc.slice(0, -2),
                    revenu: parseFloat(value.revenu),
                    profitmargin: parseFloat(parseFloat(value.profitmargin).toFixed(scripOverviewData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])),
                });
                // Vaibhav Singh: BT-109095:09-11-23:Fixed value to decimal locator length: End
            });
            setfilterTrendAnalysis(dataFilterVal?.reverse());
        }
    }, [scripOverviewData, trendAnalysis]);
    useEffect(() => {
        if (trendAnalysis?.length === 0) {
            const exchangeType = getAssetExchangeNameFromMktSegId(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            const objPayload = {
                // BT-114569 : Functional Implementation : Vaibhav Singh : 01-07-2023 : fixed for apicall when inline search is triggered
                nToken: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
                exchangeType: exchangeType,
                quarterlyTend: apiQuarterlyTrendValues[activeTabKey],
                jtenantToken: 1,
            };
            dispatch(getQuarterlyTrendData(objPayload));
        }
    }, [activeTabKey, dispatch, scripOverviewData, trendAnalysis]);
    useEffect(() => {
        if (trendAnalysis?.length > 0) {
            const exchangeType = getAssetExchangeNameFromMktSegId(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
            const objPayload = {
                nToken: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
                exchangeType: exchangeType,
                quarterlyTend: apiQuarterlyTrendValues[activeTabKey],
                jtenantToken: 1,
            };
            dispatch(getQuarterlyTrendData(objPayload));
        }
        //Vaibhav Singh: BT-109095: 08-01-24: Dependency updated: Start
    }, [activeTabKey, dispatch]);
    // Vaibhav Singh: BT-109095: 08-01-24: Dependency updated: ends
    //BT-109095: Functional Implementation : Vaibhav Singh : 26-07-2023 : Added BzTab to remove console errors

    const handleTabChange = (value) => {
        setActiveTabKey(value);
        if (value === "netrevenue") {
            setLables(["Net Revenue", "Gross Profit Margin"]);
        } else if (value === "ebit") {
            setLables(["EBIT", "EBIT Margin"]);
        } else if (value === "ebitda") {
            setLables(["EBITDA", "EBITDA Margin"]);
        } else if (value === "netprofit") {
            setLables(["Net Profit", "Net Profit Margin"]);
        }
    };

    // Hari k:04-11-2024 :trend analysis chart -start
    const calculateScaleParams = (min, max, tickCount = 4) => {
        const range = max - min;
        const roughStep = Math.pow(10, Math.floor(Math.log10(range / (tickCount - 1))));
        const stepSize = Math.ceil(range / (tickCount - 1) / roughStep) * roughStep;

        const margin = stepSize * 0.1;
        const roundedMin = Math.floor((min - margin) / stepSize) * stepSize;
        const roundedMax = Math.ceil((max + margin) / stepSize) * stepSize;

        return {
            stepSize,
            min: roundedMin,
            max: roundedMax,
            tickCount,
        };
    };


    const theme = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.THEME);
    const labels = filterTrendAnalysis.map((item) => item.yrc);
    const revenueData = filterTrendAnalysis.map((item) => item.revenu);
    const profitMarginData = filterTrendAnalysis.map((item) => item.profitmargin);

    const minRevenue = Math.min(...revenueData);
    const maxRevenue = Math.max(...revenueData);
    const minProfitMargin = Math.min(...profitMarginData);
    const maxProfitMargin = Math.max(...profitMarginData);

    const revenueScale = calculateScaleParams(minRevenue, maxRevenue);
    const profitMarginScale = calculateScaleParams(minProfitMargin, maxProfitMargin);

    const [visibleDatasets, setVisibleDatasets] = useState({
        revenue: true,
        profitMargin: true,
    });

    const toggleDatasetVisibility = (datasetType) => {
        setVisibleDatasets((prevState) => ({
            ...prevState,
            [datasetType]: !prevState[datasetType],
        }));
    };



    const data = {
        labels: labels,
        datasets: [
            {
                type: 'bar',
                label: 'Revenue (Cr)',
                data: visibleDatasets.revenue ? revenueData : Array(revenueData.length).fill(null),
                backgroundColor: 'rgba(0, 123, 255, 0.6)',
                borderWidth: 1,
                yAxisID: 'y-revenue',
                order: 2,
                pointStyle: 'circyle',
                pointRadius: 2,
                pointHoverRadius: 5,
                datalabels: {
                    display: false // Ensures no data labels are shown
                }
            },
            {
                type: 'line',
                label: 'Profit Margin %',
                data: visibleDatasets.profitMargin ? profitMarginData : Array(profitMarginData.length).fill(null),
                borderColor: theme === THEME_TYPE.DARK ? "white" : 'blue',
                fill: false,
                tension: 0.4,
                pointBorderColor: theme === THEME_TYPE.DARK ? "white" : 'blue',
                pointBackgroundColor: theme === THEME_TYPE.DARK ? "white" : 'blue',
                pointRadius: 5,
                borderWidth: 3,
                yAxisID: 'y-profit',
                order: 1,
                pointStyle: 'circyle',
                pointRadius: 2,
                pointHoverRadius: 5,
                datalabels: {
                    display: false // Ensures no data labels are shown
                }
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
                onClick: (event, legendItem) => {
                    const datasetType = legendItem.text === 'Revenue (Cr)' ? 'revenue' : 'profitMargin';
                    toggleDatasetVisibility(datasetType);
                },
                labels: {
                    usePointStyle: true,
                    boxWidth: 20,
                    padding: 20,
                    font: {
                        size: 14,
                    },
                    color: theme === THEME_TYPE.DARK ? "white" : 'black',
                },
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => {
                        const value = tooltipItem.raw;
                        return `Value: ${value}`;
                    },
                },
                padding: 10,
                displayColors: false,
            },
        },
        scales: {
            'y-revenue': {
                type: 'linear',
                position: 'left',
                min: revenueScale.min,
                max: revenueScale.max,
                ticks: {
                    maxTicksLimit: 4,
                    stepSize: revenueScale.stepSize,
                    callback: (value) => {
                        if (!visibleDatasets.revenue)
                            return ''
                        return Number.isInteger(value) ? value : value.toFixed(2)
                    },
                    maxTicksLimit: revenueScale.tickCount,
                    color: theme === THEME_TYPE.DARK ? "white" : 'black',
                },
                grid: {
                    display: false,
                    color: theme === THEME_TYPE.DARK ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
                },
                display: visibleDatasets.revenue,
            },
            'y-profit': {
                type: 'linear',
                position: 'right',
                min: profitMarginScale.min,
                max: profitMarginScale.max,
                ticks: {
                    maxTicksLimit: 4,
                    stepSize: profitMarginScale.stepSize,
                    callback: (value) => {
                        if (!visibleDatasets.profitMargin) return ''
                        return Number.isInteger(value) ? value : value.toFixed(2)
                    },
                    maxTicksLimit: profitMarginScale.tickCount,
                    color: theme === THEME_TYPE.DARK ? 'white' : 'black',
                },
                grid: {
                    display: false,
                    color: theme === THEME_TYPE.DARK ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
                },
                display: visibleDatasets.profitMargin,
            },
            x: {
                ticks: {
                    color: theme === THEME_TYPE.DARK ? 'white' : 'black',
                },
                grid: {
                    display: false,
                    color: theme === THEME_TYPE.DARK ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
                },
            },
        },
        layout: {
            padding: {
                top: 40,
            },
        }, elements: {
            point: {
                radius: 4, // Ensures points are not shown on the line
                hoverRadius: 2,
                hitRadius: 2
            }
        }
    };
    useEffect(() => {
        if (expandScripOverviewModel) {
            const canvas = document.querySelector('#chart-canvas')
            if (canvas) {
                canvas.style.height = '79%'
                canvas.style.width = '99%'
            } else { }
        }
        else { }

    }, [expandScripOverviewModel])
    // Hari k:04-11-2024 :trend analysis chart -end

    return (<>
        <Container data-testid="market-overview-trend-analysis-section" fluid className='p-0 mt-3'>
            <div className='scripoverview-fieldset'>
                    <div className='scripoverview-legend'>TREND ANALYSIS</div>
                    <Row className='g-0 mt-3'>
                        <Col>
                            <Stack direction="horizontal" className='d-flex submenu-wrapper pb-3'>
                                <div data-testid="market-overview-analysis-net-revenue-button" className={`submenuItem ${activeTabKey === 'netrevenue' ? "active" : ""} font-size3 submenuItem`} isActive={activeTabKey === 'netrevenue' ? true : false} onClick={() => handleTabChange('netrevenue')} tabKey='netrevenue'>Net Revenue</div>
                                <div data-testid="market-overview-analysis-ebit-button" className={`submenuItem ${activeTabKey === 'ebit' ? "active" : ""} font-size3 submenuItem`} isActive={activeTabKey === 'ebit' ? true : false} onClick={() => handleTabChange('ebit')} tabKey='ebit'>EBIT</div>
                                <div data-testid="market-overview-analysis-ebitda-button" className={`submenuItem ${activeTabKey === 'ebitda' ? "active" : ""} font-size3 submenuItem`} isActive={activeTabKey === 'ebitda' ? true : false} onClick={() => handleTabChange('ebitda')} tabKey='ebitda'>EBITDA</div>
                                <div data-testid="market-overview-analysis-netprofit-button" className={`submenuItem ${activeTabKey === 'netprofit' ? "active" : ""} font-size3 submenuItem`} isActive={activeTabKey === 'netprofit' ? true : false} onClick={() => handleTabChange('netprofit')} tabKey='netprofit'>Net Profit</div>
                            </Stack>
                            {(filterTrendAnalysis?.length) ?
                                <>
                                    <Row className='g-0 mt-3'>
                                        <div className='d-flex flex-row justify-content-between'>
                                            <div className='font-regular font-size2 color-subtext text-capitalize'>{lables[0]} (cr.)</div>
                                            <div className='font-regular font-size2 color-subtext text-capitalize'>{lables[1]} %</div>  {/*Bhagyashri P [20-11-2023] : BT-109095 Scrip Overview Analysis classes */}
                                        </div >
                                    </Row >
                                    <Row className='g-0'>
                                        <Col className='d-flex justify-content-center align-items-center'>
                                            <Bar data-testid="market-overview-trend-analysis-bar-chart" id='chart-canvas' data={data} options={options} />
                                        </Col>
                                    </Row>
                                </>
                                :
                                <div className='zero-state-alerts zero-state-alerts-xl'>
                                    <ZeroStates subText="Could not find any data" icon='icon-64 icon-nodata mb-3 mrgauto' />
                                </div>
                            }
                        </Col >
                    </Row >
                </div >
        </Container >
    </>);
};
export default memo(TrendAnalysis); 